import React from 'react'
import { ThemeContext } from '../../../contexts/theme'

import * as S from './styles'

export default function Loading (props) {
  const themeContext = React.useContext(ThemeContext)

  return (
    <S.Loading data-cy={props.dataCy} className={props.active ? 'active' : ''}>
      <img src={themeContext.loading_gif} alt='' />
    </S.Loading>
  )
}
